import { TagsManagerWebComponent } from './component/TagsManagerWebComponent';
import { WEB_COMPONENT_TAGS_MANAGER } from '../../webcomponents.constants';

export { TagsManagerWebComponent };

window.customElements.define(WEB_COMPONENT_TAGS_MANAGER, TagsManagerWebComponent);
